import ContextMenu from "devextreme-react/context-menu";
import { connect } from "react-redux";
import * as actions from "redux/actions/index";
import { useNavigate } from "react-router-dom";
import "./user-panel.scss";
import { confirm } from "devextreme/ui/dialog";
function UserPanel(props) {
  //
  // const

  const avatarUrl = props.avatarUrl || `https://stirisprod001.blob.core.windows.net/avatars/Avatar.jpg`;

  // useHistory

  const navigate = useNavigate();

  const menuItems = [
    {
      text: "Help",
      icon: "fad fa-info-circle",
      items: [
        {
          text: "Online",
          icon: "fad fa-globe",
          onClick: onOnline,
        },
        {
          text: "Manual",
          icon: "fad fa-book-open",
          onClick: onManual,
        },
        {
          text: "Videos",
          icon: "fad fa-video",
          onClick: onVideos,
        },
      ],
    },
    {
      text: "Setting",
      icon: "fad fa-user-cog",
      onClick: onSettings,
    },
    {
      text: "Ticket",
      icon: "fad fa-bug",
      onClick: onTicket,
    },
    {
      text: "Logout",
      icon: "fad fa-sign-out-alt",
      onClick: onLogout,
    },
  ];

  // event handlers

  async function onLogout() {
    var result = await confirm("<i>Do you really want to logout?</i>", "Confirm");
    if (result) props.onLogout();
  }

  function onOnline() {
    window.open(`https://app-irishelp-prod-001.azurewebsites.net/`, "_blank");
  }

  function onManual() {
    window.open(`https://stirisprod001.blob.core.windows.net/help/IRIS%20User%20Guide.pdf`, "_blank");
  }

  function onVideos() {
    window.open(`https://www.youtube.com/playlist?list=PLbVggrdJXQPUZ_u7DQXZnQjLFBbV_-ctQ`, "_blank");
  }

  function onSettings() {
    navigate(`/pages/user/setting`);
  }

  function onTicket() {
    navigate(`/pages/ticket`);
  }

  return (
    <div className="components-user-panel">
      <div className="user-name">{props.name}</div>
      <div className="image-container">
        <img className="image" alt="/" src={avatarUrl} />
      </div>
      <ContextMenu
        items={menuItems}
        target={".user-button"}
        showEvent={"dxclick"}
        position={{ my: "top center", at: "bottom center" }}
        cssClass={"components-user-panel-context-menu"}
      />
    </div>
  );
}

function mapsDispatchToProps(dispatch) {
  return {
    onLogout: () => dispatch(actions.logout()),
  };
}

function mapStateToProps(state) {
  return {
    name: state.user.name || "",
    avatarUrl: state.user.avatarUrl,
    storageKey: state.org.storageSasKey,
  };
}

export default connect(mapStateToProps, mapsDispatchToProps)(UserPanel);
